module.exports = __webpack_public_path__ + "img/188.0c67922d.jpg";